<script setup>
import logo from '@/assets/images/loginLogo.png'
import {
    getDatabase,
    ref as dbRef,
    get as dbGet,
} from 'firebase/database'
import { getApp } from 'firebase/app'
import { handleErrors } from '../shared/utils/errorHandler'
import { onMounted } from 'vue'
import { ref } from 'vue'
const db = getDatabase(getApp())

const messageContent = ref({
    title: '',
    subtitle: ''
})

const getContent = async () => {
    try {
        const itemsRef = dbRef(db, 'MOBILE_MESSAGE')
        const snapshot = await dbGet(itemsRef)
        if (snapshot.exists()) {
            const content = snapshot.val()
            messageContent.value = {
                title: content.mobileMessageTitle?.default_value || '',
                subtitle: content.mobileMessageSubtitle?.default_value || ''
            }
        }
    } catch (err) {
        handleErrors('Error fetching mobile message content:', err)
    }
}

onMounted(async () => {
    await getContent()
})
</script>

<template>
    <div class="mobile-message text-center">
        <div class="logo-container d-flex justify-content-center">
            <img :src="logo" alt="BCS Logo">
        </div>

        <div class="title">
            <strong>{{ messageContent.title }}</strong>
        </div>
        <div class="subtitle">
            {{ messageContent.subtitle }}
        </div>

    </div>
</template>

<style scoped lang="scss">
.mobile-message {
    padding: 0 30px;

    .logo-container {
        margin-top: 45px;

        img {
            width: 147px;
            height: auto;
        }
    }

    .title {
        font-size: 28px;
        margin-top: 33px;
        margin-bottom: 14px;
    }

    .subtitle {
        font-size: 22px;
    }
}
</style>